export default __webpack_public_path__ + "static/media/Foto-11.6379bda9.png";